/* istanbul ignore file */

import { getSectionVisibleActionType } from '@noths/polaris-client-components';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from '../slice';
import {
  PersonalisationErrorFieldEvent,
  PersonalisationExpanded,
  PersonalisationInitialImpression,
  PersonalisationInteractionFieldEvent,
  PersonalisationProgressFieldEvent,
  PRODUCT_PERSONALISATIONS_VISIBILITY_NAME,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [getSectionVisibleActionType(PRODUCT_PERSONALISATIONS_VISIBILITY_NAME)]: () => {
    sendGAEvent<PersonalisationInitialImpression>({
      event: 'custom_event',
      event_category: 'Product Personalisation',
      event_action: 'Impression',
      event_label: 'Initial Impression',
    });
  },
  [actions.toggleExpanded.type]: () => {
    sendGAEvent<PersonalisationExpanded>({
      event: 'custom_event',
      event_category: 'Product Personalisation',
      event_action: 'Impression',
      event_label: 'Expand personalisation',
    });
  },
  [actions.trackInteraction.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof actions.trackInteraction>;
    const {
      field_type,
      field_action,
      field_name,
      field_position,
      field_value,
      required_field,
    } = payload;

    sendGAEvent<PersonalisationInteractionFieldEvent>({
      event: 'custom_event',
      event_category: 'Product Personalisation',
      event_action: field_action,
      event_label: field_type,
      field_details: {
        field_name: field_name,
        field_position: field_position,
        field_type: field_type,
        field_value: field_value,
        required_field: required_field,
      },
    });
  },
  [actions.trackProgressMilestone.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof actions.trackProgressMilestone>;
    const {
      field_type,
      field_action,
      field_name,
      field_position,
      field_value,
      required_field,
    } = payload;

    sendGAEvent<PersonalisationProgressFieldEvent>({
      event: 'custom_event',
      event_category: 'Product Personalisation',
      event_action: field_action,
      event_label: field_type,
      field_details: {
        field_name: field_name,
        field_position: field_position,
        field_type: field_type,
        field_value: field_value,
        required_field: required_field,
      },
    });
  },
  [actions.trackInteractionError.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof actions.trackInteractionError>;
    const { field_type, field_action, field_name, field_position, required_field } = payload;

    if (payload.field_action === 'Add to Cart Error') {
      const eventLabel =
        field_type === 'input field'
          ? "You haven't entered any text"
          : "You haven't made a selection";

      sendGAEvent<PersonalisationErrorFieldEvent>({
        event: 'custom_event',
        event_category: 'Product Personalisation',
        event_action: payload.field_action,
        event_label: eventLabel,
        field_details: {
          field_name: field_name,
          field_position: field_position,
          field_type: field_type,
          field_value: null,
          required_field: required_field,
        },
      });
    } else if (field_action === 'Character Limit Error') {
      sendGAEvent<PersonalisationErrorFieldEvent>({
        event: 'custom_event',
        event_category: 'Product Personalisation',
        event_action: field_action,
        event_label: "You're over the character count limit",
        field_details: {
          field_name: field_name,
          field_position: field_position,
          field_type: field_type,
          field_value: null,
          required_field: required_field,
        },
      });
    }
  },
};
